import withParams from "@src/components/widgets/HOC/withParams";
import React from "react";
import { WidgetTemplateComponentType } from "@src/interface/Widget";
import { ILandingStandardWidgetAboutParams } from "../interface";
import LandingAboutMargauxMotin from "design-system/src/Components/WidgetPart/LandingAbout/LandginAboutMargauxMotin/LandginAboutMargauxMotin";

const AboutMargauxMotin: WidgetTemplateComponentType =
  withParams<ILandingStandardWidgetAboutParams>((props) => {
    const { p } = props;

    return <LandingAboutMargauxMotin description={p("description")} />;
  });

export default AboutMargauxMotin;
